import { render } from "./user-layout2.vue?vue&type=template&id=43c821ae&scoped=true"
import script from "./user-layout2.vue?vue&type=script&lang=ts"
export * from "./user-layout2.vue?vue&type=script&lang=ts"

import "./user-layout2.vue?vue&type=style&index=0&id=43c821ae&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-43c821ae"

export default script